module.exports = __webpack_public_path__ + "static/media/CaretCircleDownAccordion.323fabc8.svg";